<template>
    <section>
        <div class="bg-blue-600" v-if="texts.topbar">
            <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div class="flex items-center justify-between flex-wrap">
                    <div class="w-0 flex-1 flex items-center">
                        <span
                            class="flex p-2 rounded-lg bg-yellow-500"
                            @click="setLiveModus()"
                        >
                            <SpeakerphoneIcon
                                class="h-6 w-6 text-blue-600"
                                aria-hidden="true"
                            />
                        </span>
                        <p class="ml-3 font-medium text-white">
                            <span> {{ texts.topbar }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-6 sm:py-8">
            <div class="relative sm:py-16">
                <div
                    class="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
                >
                    <a
                        :href="url"
                        no="https://www.online-alv.nl"
                        target="_blank"
                    >
                        <logo-nl
                            height="h-32  h-32
                                my-4
                                mx-auto
                                transform
                                hover:scale-110
                                transition
                                duration-500
                                ease-in-out"
                            class="h-32 my-4 mx-auto transform hover:scale-110 transition duration-500 ease-in-out"
                        ></logo-nl>
                    </a>
                    <div
                        class="relative rounded-2xl px-6 py-10 overflow-hidden shadow-xl sm:px-12 sm:py-20 transition-colors duration-500"
                        :class="{
                            'bg-yellow-600': form.state == 'yellow',
                            'bg-green-600': form.state == 'green',
                            'bg-blue-600': form.state == 'blue',
                            'bg-red-600': form.state == 'red',
                        }"
                    >
                        <div
                            aria-hidden="true"
                            class="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0"
                        >
                            <svg
                                class="absolute inset-0 h-full w-full"
                                preserveAspectRatio="xMidYMid slice"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 1463 360"
                            >
                                <path
                                    class="text-opacity-40 transition-colors duration-500"
                                    :class="{
                                        'text-yellow-500':
                                            form.state == 'yellow',
                                        'text-green-500': form.state == 'green',
                                        'text-blue-500': form.state == 'blue',
                                        'text-red-500': form.state == 'red',
                                    }"
                                    fill="currentColor"
                                    d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
                                />
                                <path
                                    class="text-opacity-40 transition-colors duration-500"
                                    :class="{
                                        'text-yellow-700':
                                            form.state == 'yellow',
                                        'text-green-700': form.state == 'green',
                                        'text-blue-700': form.state == 'blue',
                                        'text-red-700': form.state == 'red',
                                    }"
                                    fill="currentColor"
                                    d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
                                />
                            </svg>
                        </div>
                        <div class="relative">
                            <div class="sm:text-center">
                                <h2
                                    class="text-3xl font-extrabold text-white tracking-tight sm:text-4xl"
                                >
                                    {{ texts.title }}
                                </h2>
                                <p
                                    class="mt-6 mx-auto max-w-2xl text-lg"
                                    :class="{
                                        'text-yellow-50':
                                            form.state == 'yellow',
                                        'text-green-50': form.state == 'green',
                                        'text-blue-50': form.state == 'blue',
                                        'text-red-50': form.state == 'red',
                                    }"
                                >
                                    {{ texts.content }}
                                </p>
                            </div>
                            <form
                                v-on:submit.prevent="onSubmit"
                                novalidate
                                v-if="!form.success"
                                class="mt-12 sm:mx-auto sm:max-w-lg sm:flex"
                                :class="{
                                    ' flex-col gap-y-4 flex': modus == 'live',
                                }"
                            >
                                <div
                                    class="min-w-0 flex-1"
                                    v-if="modus == 'live'"
                                >
                                    <label for="code" class="sr-only">{{
                                        texts.placeholder
                                    }}</label>
                                    <input
                                        id="code"
                                        required
                                        :disabled="loading"
                                        type="text"
                                        v-model="form.code"
                                        class="block w-full border border-transparent rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600 disabled:opacity-50"
                                        placeholder="Code"
                                    />
                                </div>

                                <div class="min-w-0 flex-1">
                                    <label for="cta_email" class="sr-only">{{
                                        texts.placeholder
                                    }}</label>
                                    <input
                                        id="cta_email"
                                        :disabled="loading"
                                        type="email"
                                        required
                                        v-model="form.email"
                                        class="block w-full border border-transparent rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600 disabled:opacity-50"
                                        :placeholder="texts.placeholder"
                                    />
                                </div>

                                <div
                                    class="mt-1 sm:mt-0 sm:ml-3"
                                    :class="{
                                        'sm:mr-3 sm:mt-4': modus == 'live',
                                        'mt-4': modus != 'live',
                                    }"
                                >
                                    <button
                                        v-if="!loading"
                                        type="submit"
                                        class="block w-full rounded-md border border-transparent px-5 py-3 text-base font-medium text-white shadow focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 sm:px-10"
                                        :class="{
                                            'bg-yellow-500 hover:bg-yellow-400 focus:ring-offset-yellow-600':
                                                form.state == 'yellow',
                                            'bg-green-500 hover:bg-green-400 focus:ring-offset-green-600':
                                                form.state == 'green',
                                            'bg-blue-500 hover:bg-blue-400 focus:ring-offset-blue-600':
                                                form.state == 'blue',
                                            'bg-red-500 hover:bg-red-400 focus:ring-offset-red-600':
                                                form.state == 'red',
                                        }"
                                    >
                                        <span>{{ texts.button }}</span>
                                    </button>
                                    <icon-loader
                                        v-if="loading"
                                        class="text-white mt-3 inline-block transition-all duration-500 ease-in-out mx-auto"
                                    ></icon-loader>
                                </div>
                            </form>
                        </div>
                    </div>

                    <footer class="my-4 w-full text-center">
                        <a
                            class="mt-2 max-w-xl text-sm leading-5 text-gray-500 hidden"
                            href="/"
                            target="_blank"
                            >© Online-ALV.nl</a
                        >
                    </footer>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SpeakerphoneIcon, XIcon } from "@heroicons/vue/outline";

export default {
    components: {
        SpeakerphoneIcon,
        XIcon,
    },
    data() {
        return {
            modus: "access",
            texts: {
                title: "Toegangsmail opnieuw opvragen",
                content:
                    "Vul hieronder uw e-mailadres in en wij sturen u een nieuwe inlog-link toe",
                // topbar: "Om in te loggen verwijzen wij u door naar de e-mail die u hebt gekregen indien u toegang mag krijgen tot deze omgeving",
                topbar: null,
                button: "Opvragen",
                placeholder: "E-mailadres",
            },
            form: {
                state: "blue",
                errors: null,
                success: false,
                email: null,
                code: null,
            },
            loading: false,
            url: "http://online-alv.nl",
            lang: "nl",
        };
    },
    mounted() {
        // this.checkAuth();
        if (this.notification_channel) {
            Eventing.listen("show2FA", () => this.$router.push("/access"));
        } else {
            Eventing.listen("show2FA", () => this.$router.push("/login"));
        }
        this.checkAuth();
    },
    created() {
        this.texts = {
            title: this.t(
                "access.login-page.title",
                "Toegangsmail opnieuw opvragen",
            ),
            content: this.t(
                "access.login-page.content",
                "Vul hieronder uw e-mailadres in en wij sturen u een nieuwe inlog-link toe",
            ),
            topbar: this.t(
                "access.login-page.topbar",
                "Om in te loggen verwijzen wij u door naar de e-mail die u hebt gekregen indien u toegang mag krijgen tot deze omgeving",
            ),
            button: this.t("access.login-page.button", "Opvragen"),
        };
        this.texts.placeholder = this.t(
            "access.login-page.placeholder-email",
            "E-mailadres",
        );
        this.lang = document.documentElement.lang.substr(0, 2);
        if (this.lang == "de") {
            this.url = "https://online-mgv.de";
        }
        if (window.location.href.includes('login-qr')) {
            localStorage.setItem('redirect-to-live', 'yes');
            this.setLiveModus();
        }
    },
    props: ["notification_channel"],
    methods: {
        setLiveModus() {
            this.modus = "live";

            this.texts = {
                title: "Welkom in de zaal",
                content:
                    "Vul hieronder de code in die bekend is gemaakt en daaronder uw emailadres dat bekend is bij uw organisatie. Hierna gaat u door naar de tweestaps verificatie stap.",
                topbar: "",
                button: "Doorgaan",
            };
            this.texts.placeholder = this.t(
                "access.login-page.placeholder-email",
                "E-mailadres",
            );
        },
        onSubmit() {
            let self = this;
            this.loading = true;
            this.form.state = "yellow";
            if (self.modus != "live") {
                this.texts.title = this.t(
                    "access.login-page.title-submit",
                    "Toegangsmail",
                );
            }
            axios
                .post("/request-access", {
                    email: this.form.email,
                    code: this.modus == "live" ? this.form.code : null,
                })
                .then((response) => {
                    this.form.state = "green";
                    if (self.modus == "live") {
                        if (response.data.login) {
                            this.form.success = true;
                            return (window.location = response.data.login);
                        } else {
                            this.form.state = "red";
                        }
                    } else {
                        this.texts.content = this.t(
                            "access.login-page.content-success-submit",
                            "U ontvangt een e-mail indien het e-mailadres bij ons bekend is.",
                        );
                        this.form.success = true;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.form.state = "red";
                    this.texts.content = "";
                    if (error.response.status == 422) {
                        var errors = error.response.data.errors;

                        try {
                            this.texts.content = errors["code"].toString();
                        } catch (error) {}
                        try {
                            this.texts.content = errors["email"].toString();
                        } catch (error) {}

                        setTimeout(function () {
                            if (self.form.state == "red") {
                                self.form.state = "blue";
                            }
                        }, 3000);
                    } else {
                        this.texts.title = "Error: " + error.response.status;
                    }
                    this.form.email = null;
                    this.form.code = null;
                    this.loading = false;
                });
        },
        checkAuth() {
            axios
                .post("/auth?view=login")
                .then((response) => {
                    if (response.data.user) {
                        this.$router.push("/dashboard");
                    }
                })
                .catch((error) => {
                    if (error.response.status == 418) {
                        // this.$router.push("/access");
                        window.location.href = "app/#/access";
                    }
                });
        },
    },
};
</script>
